import { Injectable } from '@angular/core';
import { param } from '@app/model/paramobj';
import { I18nService } from '@app/core';
import { Http } from '@angular/http';
import { CryptographyService } from '@app/cryptography.service'
import { environment } from '@env/environment';
import { NotiService } from '@app/noti.service';

declare var $: any, moment: any
@Injectable()
export class UtilService {
  [x: string]: any;

  constructor(

    private i18nService: I18nService,
    private http: Http,
    private crypto: CryptographyService,
    private notiService: NotiService
  ) { }

  ConfirmDialog(msg: string) {
    $('#lblMainConfirmMessage').html(msg);
    $('#dlgMainConfirm').modal({
      backdrop: 'static',
      keyboard: false
    });
  }
  SuccessDialog(msg: string) {
    $('#lblMainSuccess').html(msg);
    $('#dlgMainSuccess').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#btnSuccessOK').off('click');
  }
  ErrorDialog(msg: string) {
    $('#lblMainError').html(msg);
    $('#dlgMainError').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#btnMainError').off('click');
  }
  WarningDialog(msg: string) {
    $('#lblMainWarning').html(msg);
    $('#dlgMainWarning').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#btnWarningOK').off('click');
  }
  ValidateForm(divId?: string) {
    var check = 0;
    var target = 'div#divMainTemplate'
    if (divId != null) {
      target = target + ' ' + divId;
    }

    $(target).find('input,select,textarea').each(function () {
      if ($(this).prop('required')) {
        $(this).on("change paste keyup", function () {
          if ($(this).val() != null || $(this).val() != '') {
            $(this).removeClass("requiredvalid");
          }
        });
        if ($(this).val() == null || $(this).val() == '') {
          if (check == 0) {
            $(this).focus();
          }
          $(this).addClass("requiredvalid");
          check++;
        } else {
          $(this).removeClass("requiredvalid");
        }
      }
    });
    if (check == 0) {
      return true;
    } else {
      this.ErrorDialog('กรุณากรอกค่าให้ครบถ้วน');
      return false;
    }
  }

  ClearObj(obj: any) {
    for (let prop in obj) {
      obj[prop] = null;
    }
    return obj;
  }

  InitPermiss() {
    const objSessionCurrent = JSON.parse(sessionStorage.getItem('current_page_permiss'));
    if (objSessionCurrent != null) {
      if (objSessionCurrent.add_status == 1) {
        $('[role=add]').removeAttr('disabled');
        $('[role=add]').css('cursor', 'pointer');
      } else {
        $('[role=add]').attr('disabled', 'disabled');
        $('[role=add]').css('cursor', 'not-allowed');
      }
      if (objSessionCurrent.edit_status == 1) {
        $('[role=edit]').removeAttr('disabled');
        $('[role=edit]').css('cursor', 'pointer');
      } else {
        $('[role=edit]').attr('disabled', 'disabled');
        $('[role=edit]').css('cursor', 'not-allowed');
      }
      if (objSessionCurrent.delete_status == 1) {
        $('[role=delete]').removeAttr('disabled');
        $('[role=delete]').css('cursor', 'pointer');
      } else {
        $('[role=delete]').attr('disabled', 'disabled');
        $('[role=delete]').css('cursor', 'not-allowed');
      }
      if (objSessionCurrent.view_status == 1) {
        $('[role=view]').removeAttr('disabled');
        $('[role=view]').css('cursor', 'pointer');
      } else {
        $('[role=view]').attr('disabled', 'disabled');
        $('[role=view]').css('cursor', 'not-allowed');
      }
      if (objSessionCurrent.print_status == 1) {
        $('[role=print]').removeAttr('disabled');
        $('[role=print]').css('cursor', 'pointer');
      } else {
        $('[role=print]').attr('disabled', 'disabled');
        $('[role=print]').css('cursor', 'not-allowed');
      }
      if (objSessionCurrent.save_status == 1) {
        $('[role=save]').removeAttr('disabled');
        $('[role=save]').css('cursor', 'pointer');
      } else {
        $('[role=save]').attr('disabled', 'disabled');
        $('[role=save]').css('cursor', 'not-allowed');
      }
    }
  }
  InitValidation() {
    this.Validate_DatatypeInt('number');
    this.Validate_TextThaiOnly('txtThai');
    this.Validate_TextEngOnly('txtEng');
    this.Validate_DatatypeFloat('float');
  }

  Validate_DatatypeInt(targetClass: string) {
    $('.' + targetClass).on('keydown', function (e: any) {
      if (e.keyCode != 8 //backspace
        && e.keyCode != 9 //tap
        && e.keyCode != 46 //delete
        && e.keyCode != 37 //arrow left
        && e.keyCode != 39 //arrow right
        && !((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) //not number
        //&& e.key.match(/[0-9]/g) == null
      ) {
        e.preventDefault();
      }
    });

    $('.' + targetClass).on('input', function (e: any) {
      if (this.value != "") {
        if (this.value.replace(/[^0-9]+/g, "") == "") {
          this.value = "";
        }

      }
    });

    $('.' + targetClass).on('change', function () {
      if (this.value.replace(/[^0-9]+/g, "") == "") {
        this.value = "";
      } else {
        this.value = this.value.replace(/[^0-9]+/g, "");

      }
    });
  }

  Validate_DatatypeFloat(targetClass: string) {
    $('.' + targetClass).on('keydown', function (e: any) {
      if (e.keyCode != 8 //backspace
        && e.keyCode != 9 //tap
        && e.keyCode != 46 //delete
        && e.keyCode != 37 //arrow left
        && e.keyCode != 39 //arrow right
        && !((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) //not number
        //&& e.key.match(/[0-9]/g) == null
      ) {
        e.preventDefault();
      }
    });

    $('.' + targetClass).on("keypress keyup blur", function (e: any) {
      //this.value = this.value.replace(/[^0-9\.]/g,'');
      $(this).val($(this).val().replace(/[^0-9\.]/g, ''));
      if ((e.which != 46 || $(this).val().indexOf('.') != -1) && (e.which < 48 || e.which > 57)) {
        e.preventDefault();
      }
    });
  }

  Validate_DatatypeIntTimeHHmm(targetClass: string) {
    $('.' + targetClass).on('keydown', function (e: any) {
      if (e.keyCode != 8 //backspace
        && e.keyCode != 9 //tap
        && e.keyCode != 46 //delete
        && e.keyCode != 37 //arrow left
        && e.keyCode != 39 //arrow right
        && !((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) //not number
        //&& e.key.match(/[0-9]/g) == null
      ) {
        e.preventDefault();
      }
      if (this.value.length >= 2) {
        //this.value = this.value.replace(/[^0-9]+/g, "");
        this.value = "";
      }
    });

    $('.' + targetClass).on('input', function (e: any) {
      if (this.value != "") {
        if (this.value.replace(/[^0-9]+/g, "") == "") {
          this.value = "";

        }

      }
    });

    $('.' + targetClass).on('change', function () {
      if (this.value.replace(/[^0-9]+/g, "") == "") {
        this.value = "";
      } else {
        this.value = this.value.replace(/[^0-9]+/g, "");
      }
    });
  }

  Validate_TextThaiOnly(targetClass: string) {
    $('.' + targetClass).on('keydown', function (e: any) {
      if (e != undefined) {
        if (e.key.match(/^[ก-๋์.-]+$/g) == null //not thai language
          && e.keyCode != 32 //not spece bar
          && e.keyCode != 8 //backspace
          && e.keyCode != 9 //ta
          && e.keyCode != 46 //delete
          && e.keyCode != 37 //arrow left
          && e.keyCode != 39 //arrow right
        ) {
          e.preventDefault();
        }
      }
    });

    $('.' + targetClass).on('change', function () {
      if (this.value != "") {
        // if (!this.value.match(/(^[^๑-๙]+[ก-๋์]+\s?[ก-๋์*]+$)+/g))
        if (!this.value.match(/^([ก-๋์.-]\s?([ก-๋์.-])*)*$/g))
          this.value = "";
      }
      this.value = this.value.replace(/([&!฿"^])*/g, "");
    });
  }

  Validate_TextEngOnly(targetClass: string) {
    $('.' + targetClass).on('keydown', function (e: any) {
      if (e.key.match(/^[a-zA-Z.-]+$/g) == null //not thai language
        && e.keyCode != 32 //not spece bar
        && e.keyCode != 8 //backspace
        && e.keyCode != 9 //tap
        && e.keyCode != 46 //delete
        && e.keyCode != 37 //arrow left
        && e.keyCode != 39 //arrow right
      ) {
        e.preventDefault();
      }
    });

    $('.' + targetClass).on('change', function () {
      if (this.value != "") {
        if (!this.value.match(/^([a-zA-Z.-]\s?([a-zA-z.-])*)*$/g))
          this.value = "";
      }

    });
  }

  GetClientIP() {
    // var _window = (window as any);
    // // NOTE: window.RTCPeerConnection is "not a constructor" in FF22/23
    // var RTCPeerConnection = /*window.RTCPeerConnection ||*/ _window.webkitRTCPeerConnection || _window.mozRTCPeerConnection;

    // if (RTCPeerConnection) (function () {
    //     var rtc = new RTCPeerConnection({ iceServers: [] });
    //     if (1 || _window.mozRTCPeerConnection) {      // FF [and now Chrome!] needs a channel/stream to proceed
    //         rtc.createDataChannel('', { reliable: false });
    //     };

    //     rtc.onicecandidate = function (evt: any) {
    //         // convert the candidate to SDP so we can run it through our general parser
    //         // see https://twitter.com/lancestout/status/525796175425720320 for details
    //         if (evt.candidate) grepSDP("a=" + evt.candidate.candidate);
    //     };
    //     rtc.createOffer(function (offerDesc: any) {
    //         grepSDP(offerDesc.sdp);
    //         rtc.setLocalDescription(offerDesc);
    //     }, function (e: any) { console.warn("offer failed", e); });


    //     var addrs = Object.create(null);
    //     addrs["0.0.0.0"] = false;
    //     function updateDisplay(newAddr: any) {
    //         if (newAddr in addrs) return;
    //         else addrs[newAddr] = true;
    //         var displayAddrs = Object.keys(addrs).filter(function (k) { return addrs[k]; });

    //         var ip = displayAddrs[0];//.join(" or perhaps ") || "n/a";
    //         sessionStorage.setItem("clientIP", ip);
    //         //document.getElementById('list').textContent = displayAddrs.join(" or perhaps ") || "n/a";
    //     }

    //     function grepSDP(sdp: any) {
    //         var hosts = [];
    //         sdp.split('\r\n').forEach(function (line: any) { // c.f. http://tools.ietf.org/html/rfc4566#page-39
    //             if (~line.indexOf("a=candidate")) {     // http://tools.ietf.org/html/rfc4566#section-5.13
    //                 var parts = line.split(' '),        // http://tools.ietf.org/html/rfc5245#section-15.1
    //                     addr = parts[4],
    //                     type = parts[7];
    //                 if (type === 'host') updateDisplay(addr);
    //             } else if (~line.indexOf("c=")) {       // http://tools.ietf.org/html/rfc4566#section-5.7
    //                 var parts = line.split(' '),
    //                     addr = parts[2];
    //                 updateDisplay(addr);
    //             }
    //         });
    //     }
    // })(); else {
    //     var ip = "<code>ifconfig | grep inet | grep -v inet6 | cut -d\" \" -f2 | tail -n1</code>";
    //     //document.getElementById('list').innerHTML = "<code>ifconfig | grep inet | grep -v inet6 | cut -d\" \" -f2 | tail -n1</code>";
    // }

    return sessionStorage.getItem("clientIP");
  }

  DateToDB(sdate: any, time?: any) {
    if (sdate != null && sdate != '') {
      var res = sdate.split('/');
      var year = parseInt(res[2]);
      if (year > 2500) {
        year = year - 543;
      }
      if (time == '' || time == null) {
        time = "00:00:00";
      }
      return year + '-' + res[1] + '-' + res[0] + ' ' + time;
    } else {
      return sdate;
    }
  }
  ConvertToAD(buddistDate: any) {
    if (buddistDate != null && buddistDate != '') {
      var res = buddistDate.split('/');
      var year = parseInt(res[2]);
      if (year > 2500) {
        year = year - 543;
      }
      if (res[0].length == 1) {
        res[0] = '0' + res[0];
      }
      if (res[1].length == 1) {
        res[1] = '0' + res[1];
      }
      return res[0] + '/' + res[1] + '/' + year;
    } else {
      return buddistDate;
    }
  }

  ConvertToADYYYMMDD(buddistDate: any) {
    if (buddistDate != null && buddistDate != '') {
      var res = buddistDate.split('/');
      var year = parseInt(res[2]);
      if (year > 2500) {
        year = year - 543;
      }
      if (res[0].length == 1) {
        res[0] = '0' + res[0];
      }
      if (res[1].length == 1) {
        res[1] = '0' + res[1];
      }
      return  year + '/' + res[1] + '/' + res[0];
    } else {
      return buddistDate;
    }
  }

  ConvertToBE(buddistDate: any) {
    if (buddistDate != null && buddistDate != '') {
      var res = buddistDate.split('/');
      var year = parseInt(res[2]);
      if (year < 2500) {
        year = year + 543;
      }
      if (res[0].length == 1) {
        res[0] = '0' + res[0];
      }
      if (res[1].length == 1) {
        res[1] = '0' + res[1];
      }
      return res[0] + '/' + res[1] + '/' + year;
    } else {
      return buddistDate;
    }
  }

  DisPlayDate(DateStr: string) {
    if (DateStr != null && DateStr != '') {
      if (this.GetLanguage() == 'th-TH') {
        var x = DateStr.substring(0, 10);
        var t = DateStr.substring(10, DateStr.length);
        x = this.ConvertToBE(x);
        return x + t;
      } else {
        return DateStr;
      }
    } else {
      return DateStr;
    }
  }

  DisPlayDateWithOutTime(DateStr: string) {
    if (DateStr != null && DateStr != '') {
      if (this.GetLanguage() == 'th-TH') {
        var x = DateStr.substring(0, 10);

        x = this.ConvertToBE(x);
        console.log(x);
        return x;
      } else {
        var x = DateStr.substring(0, 10);

        x = this.ConvertToBE(x);
        console.log(x);
        return x;
      }
    } else {
      return DateStr;
    }
  }

  ShowWaiting(loading: boolean) {
    if (loading) {
      $('#waitingDialog').modal('show');
      console.log('show waiting');
    }
    else {
      console.log('hide waiting');
      $('#waitingDialog').modal('hide');
    }
  }
  GetCurrIP() {
    var clientIP = sessionStorage.getItem('clientIP');
    return clientIP;
  }

  GetLanguage() {
    return this.i18nService.language;
  }

  GetSiteMap() {
    return "";
    // return $('#divSiteMap').html();
  }

  SetSiteMap(x: any) {
    //$('#divSiteMap').html(x);
  }

  GetUserID() {
    var member_info: any = JSON.parse(sessionStorage.getItem('member_obj'));
    if (member_info != null) {
      return member_info.member_no;
    }
  }
  InitBranch(isAll: any, idSelect: any) {
    var member_info: any = JSON.parse(sessionStorage.getItem('member_obj'));
    if (member_info != null) {
      if (isAll) {
        this.InitDropdownAll(member_info.listBranch, idSelect);
      } else {
        this.InitDropdown(member_info.listBranch, idSelect);
      }
    }
  }

  async InitDropdown(obj: any, idSelect: any) {
    $('#' + idSelect).find('option').remove().end();
    if (obj != null) {
      if (obj.length > 0) {
        const select = document.getElementById(idSelect);
        const opt = document.createElement('option');
        opt.value = '';
        opt.innerHTML = 'เลือก';
        opt.selected = true;
        select.appendChild(opt);
        for (let i = 0; i < obj.length; i++) {
          const opt2 = document.createElement('option');
          opt2.value = obj[i].ddl_value;
          opt2.innerHTML = obj[i].ddl_text;

          select.appendChild(opt2);
        }

      }
    }
  }

  async InitDropdownAll(obj: any, idSelect: any) {
    $('#' + idSelect).find('option').remove().end();
    const select = document.getElementById(idSelect);
    const opt = document.createElement('option');
    opt.value = ''
    if (this.GetLanguage() == 'en-US') {
      opt.innerHTML = 'All'
    } else {
      opt.innerHTML = 'ทั้งหมด'
    }
    select.appendChild(opt);
    if (obj != null) {
      if (obj.length > 0) {
        for (let i = 0; i < obj.length; i++) {
          const opt = document.createElement('option');
          opt.value = obj[i].ddl_value;
          opt.innerHTML = obj[i].ddl_text;
          if (i == 0) {
            opt.selected = true;
          }
          select.appendChild(opt);
        }


      }
    }
    $("select#" + idSelect)[0].selectedIndex = 0;
  }

  GetStartCurrentDate() {
    var d = new Date();

    var mont = d.getMonth();
    var day = d.getDate();
    var dayStr = '' + day;
    var monStr = '' + mont;
    var year = d.getFullYear();
    var yearStr = '' + d.getFullYear();

    if (day < 10) {
      dayStr = '0' + day;
    }
    if (mont < 10) {
      monStr = '0' + mont;
    }
    if (year > 2500) {
      yearStr = (year - 543) + '';
    }

    var d2 = new Date(parseInt(yearStr), mont, 1);
    return d2;
  }

  GetEndCurrentDate() {
    var d = new Date();

    var mont = d.getMonth() + 1;
    var day = d.getDate();
    var dayStr = '' + day;
    var monStr = '' + mont;
    var year = d.getFullYear();
    var yearStr = '' + d.getFullYear();

    if (day < 10) {
      dayStr = '0' + day;
    }
    if (mont < 10) {
      monStr = '0' + mont;
    }
    if (year > 2500) {
      yearStr = (year - 543) + '';
    }

    var d2 = new Date(parseInt(yearStr), mont, 0);
    return d2;
  }

  GetStartCurrentDateYear() {
    var d = new Date();

    var mont = d.getMonth();
    var day = d.getDate();
    var dayStr = '' + day;
    var monStr = '' + mont;
    var year = d.getFullYear();
    var yearStr = '' + d.getFullYear();

    if (day < 10) {
      dayStr = '0' + day;
    }
    if (mont < 10) {
      monStr = '0' + mont;
    }
    if (year > 2500) {
      yearStr = (year - 543) + '';
    }

    var d2 = new Date(parseInt(yearStr), 0, 1);
    return d2;
  }

  GetEndCurrentDateYear() {
    var d = new Date();

    var mont = d.getMonth() + 1;
    var day = d.getDate();
    var dayStr = '' + day;
    var monStr = '' + mont;
    var year = d.getFullYear();
    var yearStr = '' + d.getFullYear();

    if (day < 10) {
      dayStr = '0' + day;
    }
    if (mont < 10) {
      monStr = '0' + mont;
    }
    if (year > 2500) {
      yearStr = (year - 543) + '';
    }

    var d2 = new Date(parseInt(yearStr), 11, 31);
    return d2;
  }

  checkTime(i: any) {
    if (i < 10) { i = "0" + i };  // add zero in front of numbers < 10
    return i;
  }
  checkTime2(i: any) {
    if (i < 100) { i = "0" + i };
    return i;
  }

  TableExcelReport(id: any, filename: any, coldis?: any, colName?: any, coldis2?: any, coldis3?: any, coldis4?: any, coldis5?: any, coldis6?: any) {
    var table = $('#' + id).DataTable();
    var form_data = table.rows().data();

    console.log('form_data', table.columns().context[0].aoColumns[0].data);
    if (form_data != null) {
      if (form_data.length > 0) {
        //So, to get all data do:
        if (coldis == null) {
          coldis = -1;
        }
        if (coldis2 == null) {
          coldis2 = -1;
        }
        if (coldis3 == null) {
          coldis3 = -1;
        }
        if (coldis4 == null) {
          coldis4 = -1;
        }
        if (coldis5 == null) {
          coldis5 = -1;
        }
        if (coldis6 == null) {
          coldis6 = -1;
        }


        //console.log('form_data', form_data);
        var nRow = $('#' + id + ' thead tr')[0];

        var tab_text = '<table border="1" ><tr>';

        $.each(nRow.cells, function (i: any, v: any) {
          if (i != coldis && i != coldis2 && i != coldis3 && i != coldis4 && i != coldis5 && i != coldis6) {
            tab_text += "<td>" + v.innerHTML + "</td>";

          }


        });
        if (colName != null && colName != '') {
          tab_text += "<td>" + colName + "</td>";
        }
        tab_text += "</tr>";

        for (var i = 0; i < form_data.length; i++) {
          tab_text += "<tr>";
          for (var j = 0; j < table.columns().context[0].aoColumns.length; j++) {
            if (j != coldis && j != coldis2 && j != coldis3 && j != coldis4 && j != coldis5 && j != coldis6) {
              if (form_data[i][table.columns().context[0].aoColumns[j].data] == null) {
                tab_text += "<td></td>";
              } else {
                tab_text += "<td style='mso-number-format:\\@'>" + form_data[i][table.columns().context[0].aoColumns[j].data] + "</td>";
              }

            }
          }
          tab_text += "</tr>";
        }


        // var textRange; var j = 0;
        // var tab: any = document.getElementById(id); // id of table

        // for (j = 0; j < tab.rows.length; j++) {
        //     tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
        //     //tab_text=tab_text+"</tr>";
        // }

        tab_text = tab_text + "</table>";
        tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
        tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
        tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        /* if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer
         {
           txtArea1.document.open("txt/html", "replace");
           txtArea1.document.write(tab_text);
           txtArea1.document.close();
           txtArea1.focus();
           sa = txtArea1.document.execCommand("SaveAs", true, "Say Thanks to Sumit.xls");
         }
         else                 //other browser not tested on IE 11*/
        //var sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));

        var downloadLink;
        var dataType = 'application/vnd.ms-excel';
        // var tableSelect = document.getElementById(id);
        var tableHTML = tab_text.replace(/ /g, '%20');// tableSelect.outerHTML.replace(/ /g, '%20');

        // Specify file name
        filename = filename ? filename + this.GetCurrentDate() + '.xls' : 'excel_data.xls';

        // Create download link element
        downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        if (navigator.msSaveOrOpenBlob) {
          var blob = new Blob(['\ufeff', tableHTML], {
            type: dataType
          });
          navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          // Create a link to the file
          downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

          // Setting the file name
          downloadLink.download = filename;

          //triggering the function
          downloadLink.click();
        }

        //return (sa);
      } else {
        this.ErrorDialog('ไม่พบข้อมูล');
      }
    } else {
      this.ErrorDialog('ไม่พบข้อมูล');
    }
  }

  GetMonthNames(x: any) {
    var str = '';
    if (x == '01' || x == '1') {
      str = 'มกราคม';
    }
    if (x == '02' || x == '2') {
      str = 'กุมภาพันธ์';
    }
    if (x == '03' || x == '3') {
      str = 'มีนาคม';
    }
    if (x == '04' || x == '4') {
      str = 'เมษายน';
    }
    if (x == '05' || x == '5') {
      str = 'พฤษภาคม';
    }
    if (x == '06' || x == '6') {
      str = 'มิถุนายน';
    }
    if (x == '07' || x == '7') {
      str = 'กรกฎาคม';
    }
    if (x == '08' || x == '8') {
      str = 'สิงหาคม';
    }
    if (x == '09' || x == '9') {
      str = 'กันยายน';
    }
    if (x == '10' || x == '10') {
      str = 'ตุลาคม';
    }
    if (x == '11' || x == '11') {
      str = 'พฤศจิกายน';
    }
    if (x == '12' || x == '12') {
      str = 'ธันวาคม';
    }

    return str;
  }



  async PrintLetterInvest(obj: any) {
    //   var data = {}
    //   var events = $('input[name="r3"]:checked').val();
    //   var origianal_form_in = $('input[name="rformtype"]:checked').val();
    //   console.log('GUARANTOR', $('#GUARANTOR3').prop("checked"))

    //   if (events == '') {
    //     this.util.ErrorDialog('กรุณาเลือก Printing Selection')
    //   }
    //  // else {

    //     data['action'] = 'PRINT';
    //     data['events'] = events;
    //     data['function'] = 'SUBMIT';
    //     data['username'] = this.util.GetUserID();
    //     data['cpncod_in'] = this.util.GetCpnCod();
    //     data['cpnbrncod_in'] = $('#txtBranch').val();
    //     data['accbustyp_in'] = $('#txtLoanType').val();
    //     //if ($('#txtContract1').val() != '' && $('#txtContract1').val() != null) {
    //       data['text_fr0m'] = this.obj_data.contract_number;
    //    // }
    //     if ($('#txtcustomer_name').val() != '' && $('#txtcustomer_name').val() != null) {
    //       data['customer_name_in'] = $('#txtcustomer_name').val();
    //     }
    //    if ($('#txtcomp_witness').val() != '' && $('#txtcomp_witness').val() != null) {
    //       data['customer_witness'] = $('#txtcomp_witness').val();
    //    }
    //    if ($('#txtcomp_witness_name1').val() != '' && $('#txtcomp_witness_name1').val() != null) {
    //       data['office_witness1'] = $('#txtcomp_witness_name1').val();
    //   }
    //    if ($('#txtcomp_witness_name2').val() != '' && $('#txtcomp_witness_name2').val() != null) {
    //       data['office_witness2'] = $('#txtcomp_witness_name2').val();
    //     }
    //     data['origianal_form_in'] = origianal_form_in;

    //     var res: any = await this.apiService.post('ContractSetPrinting', 'PrintGuarantor', data);
    // if (res.isSuccess) {
    //if (res.responseData != null) {
    //if (res.responseData.length > 0) {
    const element: HTMLIFrameElement = document.getElementById('rptif') as HTMLIFrameElement;
    const win: Window = element.contentWindow;
    const doc: Document = win.document;
    doc.open();
    //if (events == 'CONTRACT') {
    doc.write(this.ContractSetPrintingI(obj));
    //}
    // if (events == 'GUARANTOR1') {
    //   doc.write(this.ContractSetPrintingII(res.responseData[0]));
    // }
    // if (events == 'GUARANTOR2') {
    //   doc.write(this.ContractSetPrintingII(res.responseData[0]));
    // }
    // if (events == 'GUARANTOR3') {
    //   doc.write(this.ContractSetPrintingII(res.responseData[0]));
    // }

    doc.close()
    var btnPrintClick = setInterval(() => {
      var btnprint = (<HTMLButtonElement>doc.querySelector('#btnPrint'));
      if (btnprint != null && btnprint != undefined) {
        clearInterval(btnPrintClick);
        btnprint.click();
      }
    }, 500);
    //}
    // }
    // }
    // }
  }

  GetCurrentDate() {
    var d = new Date();

    var mont = d.getMonth() + 1;
    var day = d.getDate();
    var dayStr = '' + day;
    var monStr = '' + mont;
    var year = d.getFullYear();
    var yearStr = '' + d.getFullYear();

    if (day < 10) {
      dayStr = '0' + day;
    }
    if (mont < 10) {
      monStr = '0' + mont;
    }

    return yearStr + '' + monStr + '' + dayStr;
  }

  numberWithCommas(data: any) {
    try{
      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    catch(e){
      return ""
    }
  }

  transformDate(date: string, format: string): string {
    if (date == null || date == "") {
      return ""
    }
    let ThaiDay = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์']
    let shortThaiMonth = [
      'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
      'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
    ];
    let longThaiMonth = [
      'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
      'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];

    let inputDate: any
    if (typeof date == 'string') {
      inputDate = moment(date.replace("Z", ""), "YYYYYY-MM-DDTHH:mm:ss").toDate();
    }
    else {
      inputDate = new Date(date)
    }

    let dataDate = [
      inputDate.getDay(), inputDate.getDate(), inputDate.getMonth(), inputDate.getFullYear()
    ];

    let twoDigitDate = dataDate[1] < 10 ? '0' + dataDate[1] : dataDate[1]

    let outputDateFull = [
      'วัน ' + ThaiDay[dataDate[0]],
      'ที่ ' + twoDigitDate,
      'เดือน ' + longThaiMonth[dataDate[2]],
      'พ.ศ. ' + (dataDate[3] + 543)
    ];
    let outputDateShort = [
      twoDigitDate,
      shortThaiMonth[dataDate[2]],
      dataDate[3] + 543
    ];
    let outputDateMedium = [
      twoDigitDate,
      longThaiMonth[dataDate[2]],
      dataDate[3] + 543
    ];
    let returnDate: string;
    returnDate = outputDateMedium.join(" ");
    if (format == 'full') {
      returnDate = outputDateFull.join(" ");
    }
    else if (format == 'medium') {
      returnDate = outputDateMedium.join(" ");
    }
    else if (format == 'short') {
      returnDate = outputDateShort.join(" ");
    }
    else if (format == 'shortWithTime') {
      returnDate = outputDateShort.join(" ");
      returnDate += " " + inputDate.toLocaleTimeString("th-TH")
    }
    return returnDate;
  }

  transformDateEn(date: string, format: string): string {
    if (date == null || date == "") {
      return ""
    }
    let ThaiDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    let shortThaiMonth = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    let longThaiMonth = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    let inputDate: any
    if (typeof date == 'string') {
      inputDate = moment(date.replace("Z", ""), "YYYYYY-MM-DDTHH:mm:ss").toDate();
    }
    else {
      inputDate = new Date(date)
    }

    let dataDate = [
      inputDate.getDay(), inputDate.getDate(), inputDate.getMonth(), inputDate.getFullYear()
    ];

    let twoDigitDate = dataDate[1] < 10 ? '0' + dataDate[1] : dataDate[1]

    let outputDateFull = [
      'วัน ' + ThaiDay[dataDate[0]],
      'ที่ ' + twoDigitDate,
      'เดือน ' + longThaiMonth[dataDate[2]],
      'พ.ศ. ' + (dataDate[3])
    ];
    let outputDateShort = [
      twoDigitDate,
      shortThaiMonth[dataDate[2]],
      dataDate[3]
    ];
    let outputDateMedium = [
      twoDigitDate,
      longThaiMonth[dataDate[2]],
      dataDate[3]
    ];
    let returnDate: string;
    returnDate = outputDateMedium.join(" ");
    if (format == 'full') {
      returnDate = outputDateFull.join(" ");
    }
    else if (format == 'medium') {
      returnDate = outputDateMedium.join(" ");
    }
    else if (format == 'short') {
      returnDate = outputDateShort.join(" ");
    }
    else if (format == 'shortWithTime') {
      returnDate = outputDateShort.join(" ");
      returnDate += " " + inputDate.toLocaleTimeString("th-TH")
    }
    return returnDate;
  }

  isSuccessResponse(res: any) {
    if(res != null && res["status"] != null){
      return res["status"] >= 200 && res["status"] < 300
    }
    else{
      return res != null
    }
    // return (res != null && res["status"] != null && res["status"] >= 200 && res["status"] < 300) || res.RESMSG == "SUCCESS"
    // return res != null || (res != null && res.RESMSG == "SUCCESS")
  }

  baseUrl() {
    return window.location.protocol + "//" + window.location.hostname + (window.location.port != "" ? ":" + window.location.port : "")
  }

  baseUrlNoPort() {
    //return window.location.protocol + "//" + window.location.hostname
    return environment.apiProtocol + "//" + window.location.hostname
  }

  getIPAddress() {
    return this.http.get("https://api.ipify.org/?format=json");
  }

  CreateBlobUrl(Base64Url: any) {
    const Base64Data = Base64Url.split(",")[1];
    const ContentType = Base64Url.substring(Base64Url.indexOf(":") + 1, Base64Url.indexOf(";"))
    const ByteCharacters = atob(Base64Data);
    const ByteArrays = [];
    for (let offset = 0; offset < ByteCharacters.length; offset += 512) {
      const slice = ByteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      ByteArrays.push(byteArray);
    }

    const blob = new Blob(ByteArrays, { type: ContentType });
    return URL.createObjectURL(blob);
  }

  AesDecryptDictValue(obj: any){
    return this.crypto.decryptDictValue(obj)
  }

  getMenuObj(menuList:any, code: string, isCrisis: boolean){
    if(menuList != null && menuList.length > 0) {
      let menuObj: any = menuList.filter((m: any) => {
        return m.dpa_code == code
      })
      if(menuObj != null && menuObj.length > 0){
        if(menuObj[0].dpa_enabledisable == false){
          menuObj[0].show = false
        }
        else if(menuObj[0].dpa_isdisplay == 3){
          menuObj[0].show = true
        }
        else if(menuObj[0].dpa_isdisplay == 1 && !isCrisis){
          menuObj[0].show = true
        }
        else if(menuObj[0].dpa_isdisplay == 2 && isCrisis){
          menuObj[0].show = true
        }
        else{
          menuObj[0].show = false
        }
        
        return menuObj[0]
      }
      else{
        return {}
      }
    }
    else{
      return {}
    }
  }

  GetCurrentLang(){
    let ck: any = JSON.parse(localStorage.getItem("dpa_portal"))

    if (ck == null) {
      ck = {}
      ck.lang = "th-TH"
    }
    else {
      if(ck.lang == null || ck.lang == ""){
        ck.lang = "th-TH"
      }
    }
    localStorage.setItem("dpa_portal", JSON.stringify(ck))
    return ck.lang
  }

  SetLanguage(language: string) {
    this.i18nService.language = language;
    this.notiService.langChange(this.lang);
  }

   IsNullOrUndefined<T>(obj?: T | null): boolean {
    return obj == null;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/utility/util.service.ts